import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import values from 'utils/values';
import { THEMES } from '../constants';
import css from './style.css';

const ArrowRight = ({ className, theme }) => (
  <svg
    className={classnames(css.arrow, className, css[theme])}
    viewBox="0 0 50 80"
  >
    <polyline
      fill="none"
      stroke="black"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="
0.375,0.375 45.63,38.087 0.375,75.8 "
    />
  </svg>
);

ArrowRight.defaultProps = {
  theme: THEMES.BLACK,
};

ArrowRight.propTypes = {
  theme: PropTypes.oneOf(values(THEMES)),
};

export default ArrowRight;
